import React, { useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { Link } from "react-router-dom";
import { default as logo_d, default as logo_w } from "../assets/svg/logo_w.svg";
import InputField from "../components/inputField/InputField";
import PasswordInput from "../components/inputField/PasswordInput";

function SignIn() {
  const [name, setName] = useState("");
  const [pass, setPass] = useState("");

  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const handlepassChange = (event) => {
    setPass(event.target.value);
  };

  return (
    <div className="logIn_page">
      <div className="log_container">
        <div className="lgoIn_left">
          <Link to="/" className="logo_area">
            <img src={logo_w} className="logo logo-white" alt="" />
            <img src={logo_d} className="logo logo-dark" alt="" />
            <h4>Casso Wealth</h4>
          </Link>
          <div>
            <p>
              "Someone is sitting in the shade today because someone planted a
              tree a long time ago. The same is true with credit; using it
              wisely can lead to future financial freedom."
            </p>
            <h4 className="name">Warren Buffett</h4>
          </div>
        </div>
        <div className="logIn_from">
          <h1>
            <span>Welcome to</span> <br /> Casso Wealth
          </h1>
          <form action="" className="input_group">
            <InputField
              label="Email"
              value={name}
              onChange={handleNameChange}
              placeholder="name@example.com"
            />
            <PasswordInput
              label="Password"
              value={pass}
              onChange={handlepassChange}
              placeholder="password"
            />
            <div className="btn_area">
              <Link to="#" className="mt-3 forget">
                Forget your password?
              </Link>
              <Link to="/dashboard" className="mt-4">
                <button className="btn">Sign In</button>
              </Link>
              <span className="mt-3 or_option">OR CONTINUE WITH</span>
              <button className="btn btn_s mt-3 google_btn">
                <FcGoogle />
                Sign in with Google
              </button>
              <p className="sign_up_area">
                Create new Account. <Link to="/sign_up">Sign Up</Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
export default SignIn;
